"use client"

import { useContext } from "react"
import type { FlagContextType } from "./FlagContext"
import { FlagContext } from "./FlagContext"

export const useFlag = (flag: keyof FlagContextType["flags"]): boolean => {
  const { flags } = useContext(FlagContext)
  return Boolean(flags[flag])
}
